/* eslint-disable @nx/enforce-module-boundaries */
import { useInfiniteQuery, useMutation } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import {
  createGlobalSkills,
  getGlobalSkills,
} from 'v4/store/actions/global.data.actions';

export const useSkills = ({ search,enabled=true }) => {
  const dispatch = useDispatch();
  const tid = useRef(-1);

  useEffect(() => {
    if (search?.length) {
      clearTimeout(tid.current);
      tid.current = setTimeout(() => {
        refetch?.();
      }, 300);
    }
  }, [search]);

  const {
    mutateAsync,
    mutate,
    isLoading: createLoading,
  } = useMutation({
    mutationKey: ['global-skills-create'],
    mutationFn: async (payload) => {
      const resp = (await dispatch(createGlobalSkills(payload)))?.payload;
      refetch?.();
      return resp;
    },
    onSuccess: () => {
      refetch();
    },
  });
  const {
    isLoading,
    isFetching,
    data = { pages: [] },
    fetchNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ['global-skills', search],
    queryFn: async () => {
      return (await dispatch(getGlobalSkills({ search })))?.payload;
    },
    getNextPageParam: (lastPage, pages) => {
      if (lastPage?.next) {
        const url = new URL(lastPage.next);
        const page = url.searchParams.get('page');
        return parseInt(page, 10);
      }
      return undefined;
    },
    refetchOnWindowFocus: false,
    enabled
  });

  return {
    isLoading: isFetching,
    createLoading,
    data,
    fetchNextPage,
    refetch,
    search,
    mutate,
    mutateAsync,
  };
};
